export function getNewValue(v: any) {
  if (v == undefined) return v;
  if (Array.isArray(v)) {
    return [...v];
  } else if (typeof v === "object") {
    return { ...v };
  }
  return v;
}
